/**
 * Clear space under the tabs: the safe area less 10px (24px on a Face ID
 * iPhone), 10px where there is none. Centred in the whole bar the icons sat
 * 19px off the bottom edge, close enough for the home indicator to crowd them;
 * this keeps them about where iOS's own tab bars put theirs.
 */
export const TAB_BAR_PAD = 'max(10px, calc(env(safe-area-inset-bottom) - 10px))';
/** The tab bar: a 56px row of tabs over TAB_BAR_PAD, glass all the way to the bottom edge. */
export const TAB_BAR_HEIGHT = `calc(56px + ${TAB_BAR_PAD})`;

/**
 * Where top chrome starts: 8px below the status bar. iOS 26 softens a strip
 * just under the status bar (its scroll edge effect), which blurred the top
 * of the header's title and + button when they sat right against it.
 */
export const CHROME_TOP = 'calc(env(safe-area-inset-top) + 8px)';
/** Below a 64px header that starts at CHROME_TOP: where content under it begins. */
export const CONTENT_TOP = 'calc(72px + env(safe-area-inset-top))';
